/* tslint:disable */
/* eslint-disable */
/**
 * Course Tree API
 * API specification for course tree structure
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DidacticRule } from "./DidacticRule";
import { DidacticRuleFromJSON, DidacticRuleToJSON } from "./DidacticRule";

/**
 *
 * @export
 * @interface CourseTreeNode
 */
export interface CourseTreeNode {
  /**
   * Unique identifier for the node
   * @type {string}
   * @memberof CourseTreeNode
   */
  id: string;
  /**
   * Type of the tree node
   * @type {string}
   * @memberof CourseTreeNode
   */
  type: CourseTreeNodeTypeEnum;
  /**
   * Title of the node
   * @type {string}
   * @memberof CourseTreeNode
   */
  title: string;
  /**
   * Child nodes (recursive structure)
   * @type {Array<CourseTreeNode>}
   * @memberof CourseTreeNode
   */
  children?: Array<CourseTreeNode>;
  /**
   * Error information if any
   * @type {string}
   * @memberof CourseTreeNode
   */
  errors?: string | null;
  /**
   * Whether this is a fallback element
   * @type {boolean}
   * @memberof CourseTreeNode
   */
  fallback?: boolean;
  /**
   * Associated filename
   * @type {string}
   * @memberof CourseTreeNode
   */
  filename?: string | null;
  /**
   * Success status (DEPRECATED)
   * @type {string}
   * @memberof CourseTreeNode
   */
  succeeded?: string;
  /**
   * Last known state
   * @type {string}
   * @memberof CourseTreeNode
   */
  lastState?: string;
  /**
   * Current state status
   * @type {string}
   * @memberof CourseTreeNode
   */
  stateStatus?: string;
  /**
   *
   * @type {DidacticRule}
   * @memberof CourseTreeNode
   */
  didacticRule?: DidacticRule;
  /**
   * Reference to parent course structure
   * @type {string}
   * @memberof CourseTreeNode
   */
  courseStructureId?: string;
  /**
   * Whether storyboard generation succeeded
   * @type {boolean}
   * @memberof CourseTreeNode
   */
  storyboardSucceeded?: boolean;
  /**
   * Position index in the structure
   * @type {number}
   * @memberof CourseTreeNode
   */
  realPositionIndex?: number;
  /**
   * Markdown introduction text for module or chapter
   * @type {string}
   * @memberof CourseTreeNode
   */
  intro?: string | null;
  /**
   * Markdown outro text for chapter
   * @type {string}
   * @memberof CourseTreeNode
   */
  outro?: string | null;
  /**
   * Whether this subchapter is a module completion quiz
   * @type {boolean}
   * @memberof CourseTreeNode
   */
  moduleCompletionQuiz?: boolean;
  /**
   * Whether this subchapter is the course final quiz
   * @type {boolean}
   * @memberof CourseTreeNode
   */
  courseCompletionQuiz?: boolean;
}

/**
 * @export
 */
export const CourseTreeNodeTypeEnum = {
  Module: "module",
  Chapter: "chapter",
  Subchapter: "subchapter",
  DidacticSequence: "didactic_sequence",
  ContentElement: "content_element",
} as const;
export type CourseTreeNodeTypeEnum =
  (typeof CourseTreeNodeTypeEnum)[keyof typeof CourseTreeNodeTypeEnum];

/**
 * Check if a given object implements the CourseTreeNode interface.
 */
export function instanceOfCourseTreeNode(
  value: object
): value is CourseTreeNode {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("title" in value) || value["title"] === undefined) return false;
  return true;
}

export function CourseTreeNodeFromJSON(json: any): CourseTreeNode {
  return CourseTreeNodeFromJSONTyped(json, false);
}

export function CourseTreeNodeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CourseTreeNode {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    type: json["type"],
    title: json["title"],
    children:
      json["children"] == null
        ? undefined
        : (json["children"] as Array<any>).map(CourseTreeNodeFromJSON),
    errors: json["errors"] == null ? undefined : json["errors"],
    fallback: json["fallback"] == null ? undefined : json["fallback"],
    filename: json["filename"] == null ? undefined : json["filename"],
    succeeded: json["succeeded"] == null ? undefined : json["succeeded"],
    lastState: json["last_state"] == null ? undefined : json["last_state"],
    stateStatus:
      json["state_status"] == null ? undefined : json["state_status"],
    didacticRule:
      json["didactic_rule"] == null
        ? undefined
        : DidacticRuleFromJSON(json["didactic_rule"]),
    courseStructureId:
      json["course_structure_id"] == null
        ? undefined
        : json["course_structure_id"],
    storyboardSucceeded:
      json["storyboard_succeeded"] == null
        ? undefined
        : json["storyboard_succeeded"],
    realPositionIndex:
      json["real_position_index"] == null
        ? undefined
        : json["real_position_index"],
    intro: json["attributes"]?.["intro"] ?? json["intro"] ?? undefined,
    outro: json["attributes"]?.["outro"] ?? json["outro"] ?? undefined,
    moduleCompletionQuiz:
      json["attributes"]?.["moduleCompletionQuiz"] ??
      json["attributes"]?.["module_completion_quiz"] ??
      json["module_completion_quiz"] ??
      json["moduleCompletionQuiz"] ??
      undefined,
    courseCompletionQuiz:
      json["attributes"]?.["courseCompletionQuiz"] ??
      json["attributes"]?.["course_completion_quiz"] ??
      json["course_completion_quiz"] ??
      json["courseCompletionQuiz"] ??
      undefined,
  };
}

export function CourseTreeNodeToJSON(json: any): CourseTreeNode {
  return CourseTreeNodeToJSONTyped(json, false);
}

export function CourseTreeNodeToJSONTyped(
  value?: CourseTreeNode | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    type: value["type"],
    title: value["title"],
    children:
      value["children"] == null
        ? undefined
        : (value["children"] as Array<any>).map(CourseTreeNodeToJSON),
    errors: value["errors"],
    fallback: value["fallback"],
    filename: value["filename"],
    succeeded: value["succeeded"],
    last_state: value["lastState"],
    state_status: value["stateStatus"],
    didactic_rule: DidacticRuleToJSON(value["didacticRule"]),
    course_structure_id: value["courseStructureId"],
    storyboard_succeeded: value["storyboardSucceeded"],
    real_position_index: value["realPositionIndex"],
    intro: value["intro"],
    outro: value["outro"],
    module_completion_quiz: value["moduleCompletionQuiz"],
    course_completion_quiz: value["courseCompletionQuiz"],
  };
}
